import { Utilities } from "../../../../utils/utilities";

export class IncomePeriodDuration {
  static MONTHLY = new IncomePeriodDuration(1);
  static QUARTERLY = new IncomePeriodDuration(3);
  static ANNUALY = new IncomePeriodDuration(12);

  id: number;
  constructor(id: number) {
    this.id = id;
  }
}

export class IncomeData {
  totalPeriod = IncomePeriodDuration.ANNUALY;
  areaRent: IncomePeriodData[] = [];
  parkingRent: IncomePeriodData[] = [];
  commonRent: IncomePeriodData[] = [];
  otherRent: IncomePeriodData[] = [];

  constructor() {
    this.sumOfIncomes = this.sumOfIncomes.bind(this);
  }

  getIncomePeriodDataFromObject(data: any) {
    let newItem = new IncomePeriodData();
    newItem.description = typeof data.description === "string" ? data.description : "";
    newItem.quantity = typeof data.quantity === "number" ? data.quantity : 1;
    newItem.sum = Utilities.convertToNumber(data.sum);
    newItem.periodType = typeof data.periodType === "number" ? data.periodType : typeof data.period === "number" ? data.period : 12;
    return newItem;
  }

  setup(data: any) {
    if (!data || typeof data !== "object") return;

    if (typeof data.totalPeriod === "number") {
      this.totalPeriod = new IncomePeriodDuration(data.totalPeriod);
    }
    if (Array.isArray(data.areaRent)) {
      this.areaRent = data.areaRent.map((item: any) => this.getIncomePeriodDataFromObject(item));
    }
    if (Array.isArray(data.parkingRent)) {
      this.parkingRent = data.parkingRent.map((item: any) => this.getIncomePeriodDataFromObject(item));
    }
    if (Array.isArray(data.commonRent)) {
      this.commonRent = data.commonRent.map((item: any) => this.getIncomePeriodDataFromObject(item));
    }
    if (Array.isArray(data.otherRent)) {
      this.otherRent = data.otherRent.map((item: any) => this.getIncomePeriodDataFromObject(item));
    }
  }

  sumOfIncomes(period: number): number {
    const incomeData: any = this;
    const rents = ["areaRent", "parkingRent", "otherRent"];
    let revenueSum = 0;
    let revenueSums = [];
    for (let i in rents) {
      const rent = rents[i];
      if (incomeData[rent]) {
        let sum = 0;
        for (let j in incomeData[rent]) {
          const thisRent = incomeData[rent][j];
          sum += (Number(thisRent.quantity) * Number(thisRent.sum)) / Number(thisRent.periodType);
        }
        revenueSums.push(sum * period);
      }
    }
    if (revenueSums[0]) revenueSum += revenueSums[0];
    if (revenueSums[1]) revenueSum += revenueSums[1];
    if (revenueSums[2]) revenueSum += revenueSums[2];
    return revenueSum;
  }

  sumOfAreaRent(period: number) {
    const incomeData: any = this;
    let revenueSum = 0;
    let revenueSums = [];
    if (incomeData.areaRent) {
      let sum = 0;
      for (let j in incomeData.areaRent) {
        const thisRent = incomeData.areaRent[j];
        sum += (Number(thisRent.quantity) * Number(thisRent.sum)) / Number(thisRent.periodType);
      }
      revenueSums.push(sum * period);
    }
    if (revenueSums[0]) revenueSum += revenueSums[0];
    if (revenueSums[1]) revenueSum += revenueSums[1];
    if (revenueSums[2]) revenueSum += revenueSums[2];
    return revenueSum;
  }

  sumOfParkingRent(period: number) {
    const incomeData: any = this;
    let revenueSum = 0;
    const revenueSums = [];
    if (incomeData.parkingRent) {
      let sum = 0;
      for (let j in incomeData.parkingRent) {
        const thisRent = incomeData.parkingRent[j];
        sum += (Number(thisRent.quantity) * Number(thisRent.sum)) / Number(thisRent.periodType);
      }
      revenueSums.push(sum * period);
    }
    if (revenueSums[0]) revenueSum += revenueSums[0];
    if (revenueSums[1]) revenueSum += revenueSums[1];
    if (revenueSums[2]) revenueSum += revenueSums[2];
    return revenueSum;
  }

  sumOfCommonRent(period: number) {
    const incomeData: any = this;
    let revenueSum = 0;
    const revenueSums = [];
    if (incomeData.commonRent) {
      let sum = 0;
      for (let j in incomeData.commonRent) {
        const thisRent = incomeData.commonRent[j];
        sum += (Number(thisRent.quantity) * Number(thisRent.sum)) / Number(thisRent.periodType);
      }
      revenueSums.push(sum * period);
    }
    if (revenueSums[0]) revenueSum += revenueSums[0];
    if (revenueSums[1]) revenueSum += revenueSums[1];
    if (revenueSums[2]) revenueSum += revenueSums[2];
    return revenueSum;
  }

  sumOfOtherRent(period: number) {
    const incomeData: any = this;
    let revenueSum = 0;
    const revenueSums = [];
    if (incomeData.otherRent) {
      let sum = 0;
      for (let j in incomeData.otherRent) {
        const thisRent = incomeData.otherRent[j];
        sum += (Number(thisRent.quantity) * Number(thisRent.sum)) / Number(thisRent.periodType);
      }
      revenueSums.push(sum * period);
    }
    if (revenueSums[0]) revenueSum += revenueSums[0];
    if (revenueSums[1]) revenueSum += revenueSums[1];
    if (revenueSums[2]) revenueSum += revenueSums[2];
    return revenueSum;
  }

  sumOfParkingSpots() {
    const parkingRent = this.parkingRent;
    let parkingSpots = 0;
    if (parkingRent) {
      for (let j in parkingRent) {
        const thisRent = parkingRent[j];
        if (thisRent.quantity > 0) parkingSpots += thisRent.quantity;
      }
    }
    return parkingSpots;
  }

  protected isValidString(value: any) {
    return (typeof value === "string" || value instanceof String) && value !== "";
  }
  protected isValidNumber(value: any) {
    return typeof Utilities.convertToNumber(value) === "number" && isFinite(Utilities.convertToNumber(value));
  }
  protected isValidObject(value: any) {
    return value && typeof value === "object" && value.constructor === Object;
  }
}

export class IncomePeriodData {
  description: string = "";
  quantity: number = 1;
  sum: number = 0;
  periodType = 12;
}
